import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import config from "../../config";
import ProductsDropDown from "../Shared/ProductsDropDown";
import AccountDropDown from "../Shared/AccountDropDown";
import BoxCard from "../Shared/BoxCard";
import {
  Row,
  Col,
  message,
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Skeleton,
  DatePicker,
  Table,
  Space,
  Alert,
  Switch,
  Tooltip,
} from "antd";

import moment from "moment";
import {
  DeleteOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  PlusCircleOutlined,
  PrinterOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { NavLink, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import LoginChecked from "../Shared/LoginChecked";
import dayjs from "dayjs";
import { NumberFormat } from "../Shared/Utility";
import { NozzleOil } from "../UserControls/Icons";
import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/24/outline";

function EditSales() {
  let navigate = useNavigate();
  let params = useParams();
  const [searchParams] = useSearchParams();
  const bypassEditDaysCheck = searchParams.get("posting_fix") === "1";

  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const [ListofNozzels, setListofNozzels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingAddSale, setLoadingAddSale] = useState(false);
  const [WithoutNozzel, setWithoutNozzel] = useState(false);
  const [Is_Cash, setIs_Cash] = useState(false);
  const [Fullscreen, setFullScreen] = useState(false);
  const [CashAccountID, setCashAccountID] = useState(0);
  const [ShowNozzles, setShowNozzles] = useState();

  const [Quantity, setQuantity] = useState({});

  const accountTypesArray = AccountDropDown();

  const productTypesArray = ProductsDropDown();
  const [ProductName, setProductName] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [Price, setPrice] = useState(0);
  const [RateLoading, setRateLoading] = useState(false);
  const [productRateLoading, setProductRateLoading] = useState(false);
  const [useCustomerRate, setUseCustomerRate] = useState(true);
  const [cashRate, setCashRate] = useState(null);
  const [customerRate, setCustomerRate] = useState(null);
  const [dontClearForm, setDontClearForm] = useState(false);

  const [form] = Form.useForm();

  const [purchaseList, setPurchaseList] = useState([]);

  const [priceGroup, setpriceGroup] = useState([]);

  const [totals, setTotals] = useState({
    cashSaleTotal: 0,
    creditSaleTotal: 0,
    totalPrice: 0,
  });

  const [Dated, setDated] = useState(null);
  const [Description, setDescription] = useState("");
  const [InvoiceNo, setInvoiceNo] = useState("");

  const [ListofReadings, setListofReadings] = useState([]);
  const [ListOfSummary, setListOfSummary] = useState([]);

  const [QtyLocked, setQtyLocked] = useState(false);
  const [PriceLocked, setPriceLocked] = useState(false);

  const parseNumeric = (value) => {
    if (value === undefined || value === null || value === "") {
      return NaN;
    }
    return parseFloat(String(value).replace(/,/g, ""));
  };

  const toFormNumber = (value, maxDecimals = 6) => {
    if (isNaN(value) || value <= 0) {
      return "";
    }
    return parseFloat(value.toFixed(maxDecimals));
  };

  const formatRateForPrice = (rate) => {
    const num = parseNumeric(rate);
    if (isNaN(num)) {
      return "";
    }
    if (num <= 0) {
      return 0;
    }
    return toFormNumber(num);
  };

  const applyPriceFromRate = (rate) => {
    const formattedPrice = formatRateForPrice(rate);
    form.setFieldsValue({ Price: formattedPrice });
    setPrice(formattedPrice);

    const quantity = parseNumeric(form.getFieldValue("Quantity"));
    const unitPrice = parseNumeric(formattedPrice);
    if (!isNaN(quantity) && !isNaN(unitPrice)) {
      form.setFieldsValue({
        Total: toFormNumber(quantity * unitPrice, 2),
      });
    }
  };

  const applyActiveRate = (useCustomer, cash, customer) => {
    const rate = useCustomer ? customer : cash;
    if (rate === null || rate === undefined) {
      return;
    }
    applyPriceFromRate(rate);
  };

  const fetchProductCashRate = async (productId) => {
    const response = await axios({
      method: "post",
      url: config.base_url + "Product/GetProductByID",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        UserID: UserID,
        AccessKey: AccessKey,
        ID: productId,
      },
    });

    if (response.data.status_code === 1) {
      return response.data.Product?.Sale_Price;
    }

    return null;
  };

  const fetchCustomerRate = async (productId, accountId) => {
    const response = await axios({
      method: "post",
      url: config.base_url + "Product/GetSavedProductRateByCustomerID",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        UserID: UserID,
        AccessKey: AccessKey,
        ProductID: productId,
        AccountID: accountId,
      },
    });

    if (response.data.status_code === 1) {
      return response.data.Selling_Rate;
    }

    return null;
  };

  useEffect(() => {
    document.title = "Edit Sale";
    setLoading(true);
    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      ID: params.id,
    };
    var api_config = {
      method: "post",
      url: config.base_url + "Sale/GetSaleByID",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        
        if (response.data.status_code == 1) {
         

          let listOfSale = response.data.listofSale;

          const result = listOfSale.map((item) => ({
            ProductName: item.Product_BE?.Name,
            AccountName: item.Account_BE?.Name,
            Product_ID: item.Product_ID,
            Account_ID: item.Account_ID,
            Vehicle_No: item.Vehicle_No,
            Receipt_No: item.Receipt_No,
            Quantity: item.Quantity,
            Price: item.Price,
            Total: item.TotalAmount || item.Amount || item.Quantity * item.Price,
            Is_Cash: item.Is_Cash,
          }));

          setInvoiceNo(response.data.InvoiceNo);
          setPurchaseList(result);
          setDescription(response.data.Description);
          setDated(dayjs(response.data.Dated));
          // setListofNozzels(Nozzel);
          setListofNozzels(response.data.listofReadings);
          setListofReadings(response.data.listofReadings);
          setShowNozzles(response.data.ShowNozzles);

          setLoading(false);
        } else {
          // Handle error
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (accountTypesArray) {
      let cash = accountTypesArray.find((item) => item.label === "Cash");
      if (cash) {
        setCashAccountID(cash.value);
      }
    }

    
  }, [accountTypesArray]);

  useEffect(() => {
    const groupedData = purchaseList.reduce((acc, obj) => {
      const key = obj.Product_ID;
      if (!acc[key]) {
        acc[key] = {
          Product_ID: obj.Product_ID,
          ProductName: obj.ProductName,
          Total_Price: 0,
        };
      }
      // Prefer stored UI Total over Qty×Price
      const lineTotal = parseFloat(String(obj.Total ?? "").replace(/,/g, ""));
      acc[key].Total_Price += isNaN(lineTotal)
        ? parseFloat(obj.Quantity) * parseFloat(obj.Price)
        : lineTotal;
      return acc;
    }, {});

    setpriceGroup(Object.values(groupedData));
  }, [purchaseList]);

  useEffect(() => {
    const lineTotal = (obj) => {
      const total = parseFloat(String(obj.Total ?? "").replace(/,/g, ""));
      if (!isNaN(total) && total !== 0) {
        return total;
      }
      return parseFloat(obj.Quantity) * parseFloat(obj.Price);
    };

    const cashSaleTotal = purchaseList.reduce((acc, obj) => {
      if (obj.Is_Cash) {
        return acc + lineTotal(obj);
      }
      return acc;
    }, 0);

    const creditSaleTotal = purchaseList.reduce((acc, obj) => {
      if (!obj.Is_Cash) {
        return acc + lineTotal(obj);
      }
      return acc;
    }, 0);

    const totalPrice = purchaseList.reduce((acc, obj) => {
      return acc + lineTotal(obj);
    }, 0);

    setTotals({
      cashSaleTotal,
      creditSaleTotal,
      totalPrice,
    });
  }, [purchaseList]);

  useEffect(() => {
    // Convert Price and Quantity to numbers and calculate the total whenever they change
    const priceValue = parseFloat(Price);
    const quantityValue = parseFloat(Quantity);
    const totalValue = priceValue * quantityValue;
    const total = isNaN(totalValue) ? "" : totalValue.toString();
    form.setFieldsValue({
      total: total,
    });
  }, [Price, Quantity]);

  function handleCheckboxChange(index) {
    setPurchaseList((prevData) => {
      // Create a new copy of the purchase list
      const updatedList = [...prevData];

      // Create a new copy of the object at the given index
      const updatedItem = { ...updatedList[index] };

      // Toggle the Is_Cash value
      updatedItem.Is_Cash = !updatedItem.Is_Cash;

      // Update the list with the modified item
      updatedList[index] = updatedItem;

      return updatedList;
    });
  }

  const handleSubmit = (formData) => {
    formData["Vehicle_No"] =
      formData["Vehicle_No"] == undefined ? "" : formData["Vehicle_No"];
    formData["Receipt_No"] =
      formData["Receipt_No"] == undefined ? "" : formData["Receipt_No"];

    const data = {
      Is_Cash: Is_Cash,
      ProductName: ProductName,
      AccountName: AccountName,
      ...formData,
    };

   
    setPurchaseList((prevPurchaseList) => {
      const newPurchaseList = [...prevPurchaseList, data];
      if (!dontClearForm) {
        setIs_Cash(false);
      }
      return newPurchaseList;
    });

    if (!dontClearForm) {
      form.resetFields();
      setQtyLocked(false);
      setPriceLocked(false);
      setPrice(0);
      setQuantity(0);
      setUseCustomerRate(true);
      setCashRate(null);
      setCustomerRate(null);
    }
  };

  useEffect(() => {
    const reducedData = Object.values(
      purchaseList.reduce((acc, item) => {
        if (!acc[item.ProductName]) {
          acc[item.ProductName] = {
            ProductName: item.ProductName,
            Price: item.Price,
            Quantity: 0,
          };
        }
        acc[item.ProductName].Quantity += parseFloat(item.Quantity);
        return acc;
      }, {})
    );

    const productTotals = {};
    ListofNozzels.forEach((item) => {
      const productName = item.ProductName;
      const totalSale = parseFloat(
        item.Current_Reading - item.Last_Reading - item.Returned || 0
      );

      if (productName in productTotals) {
        productTotals[productName] += totalSale;
      } else {
        productTotals[productName] = totalSale;
      }
    });

    // Convert the productTotals object to an array
    const productTotalsArray = Object.entries(productTotals).map(
      ([ProductName, TotalSale]) => ({
        ProductName,
        TotalSale,
      })
    );
  }, [purchaseList, ListofNozzels, ProductName]);

  const handleTotalChange = () => {
    const total = form.getFieldValue("Total");
    const price = form.getFieldValue("Price");
    const quantity = form.getFieldValue("Quantity");

    if (QtyLocked) {
      if (quantity && quantity > 0) {
        const newPrice = total / quantity;
        if (!isNaN(newPrice) && newPrice > 0) {
          form.setFieldsValue({ Price: NumberFormat(newPrice, 6) });
        } else {
          form.setFieldsValue({ Price: 0 });
        }
      } else {
        form.setFieldsValue({ Price: 0 });
      }
    } else if (total && price) {
      const newQuantity = total / price;
      if (!isNaN(newQuantity) && newQuantity > 0) {
        form.setFieldsValue({ Quantity: NumberFormat(newQuantity, 6) });
      }
    }
  };

  useEffect(() => {
    const priceValue = parseFloat(Price);
    const quantityValue = parseFloat(Quantity);
    const totalValue = priceValue * quantityValue;
    const total = isNaN(totalValue) ? "" : totalValue.toString();
    form.setFieldsValue({
      total: total,
    });
  }, [Price, Quantity]);

  const handleQuantity = (e) => {
    setQuantity(e.target.value);

    const quantity = form.getFieldValue("Quantity");
    const price = form.getFieldValue("Price");
    if (quantity && price) {
      const total = NumberFormat(quantity * price, 2);
      form.setFieldsValue({ Total: total });
    }
  };

  const handlePriceChange = (e) => {
    const price = e.target.value;
    const quantity = form.getFieldValue("Quantity");

    if (price && quantity) {
      const total = price * quantity;
      form.setFieldsValue({ Total: total.toFixed(2) });
    }
    setPrice(price);
  };

  const handleProductChange = async (value, option) => {
    setProductName(option.label);
    setProductRateLoading(true);

    try {
      const salePrice = await fetchProductCashRate(value);
      setCashRate(salePrice);

      const accountId = form.getFieldValue("Account_ID");
      let nextCustomerRate = null;

      if (accountId) {
        setRateLoading(true);
        nextCustomerRate = await fetchCustomerRate(value, accountId);
        setCustomerRate(nextCustomerRate);
        setRateLoading(false);
      } else {
        setCustomerRate(null);
      }

      applyActiveRate(useCustomerRate, salePrice, nextCustomerRate);
    } catch (error) {
      console.log(error);
      message.error("Unable to load product rate");
    } finally {
      setProductRateLoading(false);
      setRateLoading(false);
    }
  };

  const handleAccountChange = async (value, option) => {
    setAccountName(option.label);

    const productId = form.getFieldValue("Product_ID");
    if (!productId) {
      return;
    }

    setRateLoading(true);

    try {
      const sellingRate = await fetchCustomerRate(productId, value);
      setCustomerRate(sellingRate);

      if (useCustomerRate) {
        applyPriceFromRate(sellingRate);
      }
    } catch (error) {
      console.log(error);
      message.error("Unable to load customer rate");
      if (useCustomerRate) {
        form.setFieldsValue({ Price: 0 });
        setPrice(0);
      }
    } finally {
      setRateLoading(false);
    }
  };

  const handleRateTypeChange = (checked) => {
    setUseCustomerRate(checked);
    applyActiveRate(checked, cashRate, customerRate);
  };
 
  const calculateQuantity = (item) => {
    return item.Current_Reading - item.Last_Reading - item.Returned;
  };

  const sortedNozzlesForTable = useMemo(() => {
    return [...ListofNozzels].sort((a, b) => {
      const pa = parseFloat(a.Pump_No);
      const pb = parseFloat(b.Pump_No);
      const na = isNaN(pa) ? 0 : pa;
      const nb = isNaN(pb) ? 0 : pb;
      return na - nb;
    });
  }, [ListofNozzels]);

  /** One row per product (all nozzles summed). Order follows pump order: first product group = first Pump_No block. */
  const nozzleProductTotals = useMemo(() => {
    const byProductKey = {};
    const orderKeys = [];
    sortedNozzlesForTable.forEach((item) => {
      const key =
        item.ProductID != null && item.ProductID !== ""
          ? String(item.ProductID)
          : `${item.ProductCode}|${item.ProductName}`;
      if (!byProductKey[key]) {
        byProductKey[key] = {
          ProductID: item.ProductID,
          ProductCode: item.ProductCode,
          ProductName: item.ProductName,
          totalQuantity: 0,
        };
        orderKeys.push(key);
      }
      const lineQty =
        parseFloat(item.Current_Reading) -
        parseFloat(item.Last_Reading) -
        parseFloat(item.Returned || 0);
      byProductKey[key].totalQuantity += isNaN(lineQty) ? 0 : lineQty;
    });
    return orderKeys.map((k) => byProductKey[k]);
  }, [sortedNozzlesForTable]);

  const handleDate = (date, value) => {
    setDated(value);
  };

  const handleSaveInvoice = () => {
    if (ShowNozzles === true) {
      if (Dated == null) {
      
        message.error("Please Select Date");
        return;
      }
      const hasPendingQuantity = ListOfSummary.some(
        (ListOfSummary) => ListOfSummary.PendingQuantity > 0
      );

      if (hasPendingQuantity) {
        message.error("Please add remaining quantity into sale detail");
        return false;
      }

      if (ListofReadings.length == 0) {
        message.error("Please enter machine readings");
        return false;
      }

      if (purchaseList.length == 0) {
        message.error("Please add cash details");
        return false;
      } else {
        if (Dated == null) {
          message.error("Please Select Date");
          return;
        }
        if (purchaseList.length == 0) {
          message.error("Please add cash details");
          return false;
        }
      }
    }
    setLoadingAddSale(true);
    const modifiedData = purchaseList.map(
      ({ AccountName, ProductName, Total, ...rest }) => {
        const totalAmount = parseFloat(String(Total ?? "").replace(/,/g, ""));
        return {
          ...rest,
          Total: isNaN(totalAmount) ? 0 : totalAmount,
          TotalAmount: isNaN(totalAmount) ? 0 : totalAmount,
        };
      }
    );

    const newArray = ListofReadings.map(
      ({ PumpMachineID, Last_Reading, Current_Reading, Returned }) => ({
        PumpMachineID,
        Last_Reading,
        Current_Reading,
        Returned,
      })
    );


    const result = ListofReadings.reduce((acc, item) => {
      // Calculate the total sale for this item
      const totalSale = item.Current_Reading - item.Last_Reading - item.Returned;
  
      // If the ProductCode already exists, add to its total
      if (acc[item.ProductCode]) {
        acc[item.ProductCode] += totalSale;
      } else {
        // Otherwise, initialize it with the current totalSale
        acc[item.ProductCode] = totalSale;
      }
  
      return acc;
    }, {});


   


  

    const data = {
      UserID: UserID,
      AccessKey: AccessKey,
      Dated: dayjs(Dated).format("YYYY-MM-DD"),
      Description: Description,
      ListofReadings: newArray,
      ListofSaleDetails: modifiedData,
      ID: params.id,
      BypassEditDaysCheck: bypassEditDaysCheck,
    };

   

    var api_config = {
      method: "post",
      url: config.base_url + "Sale/UpdateSale",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
       
        if (response.data.status_code == 1) {
          // Handle success
          message.success(response.data.status_message);
          setLoadingAddSale(false);
          navigate("/sales/view-sales")
        } else {
          // Handle error
          message.error(response.data.status_message);
          setLoadingAddSale(false);
        }
        //   setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleDelete = (index) => {
    const updatedItems = [...purchaseList];
    // Remove the item at the specified index
    updatedItems.splice(index, 1);
    // Update the state with the new array
    setPurchaseList(updatedItems);
  };

  const AddCashSale = () => {
    const productTotalsArray = [];

    // Accumulate total sales for each product
    ListofNozzels.forEach((item) => {
      const productName = item.ProductName;
      const totalSale = parseFloat(
        item.Current_Reading - item.Last_Reading - item.Returned || 0
      );

      const productIndex = productTotalsArray.findIndex(
        (product) => product.ProductName === productName
      );

      if (productIndex > -1) {
        productTotalsArray[productIndex].totalSale += totalSale;
      } else {
        productTotalsArray.push({
          Price: item.Sale_Price,
          ProductID: item.ProductID,
          ProductName: productName,
          totalSale,
        });
      }
    });

    const groupedTotalsArray = [];

    purchaseList.forEach((item) => {
      const { Product_ID, Price, Quantity, ProductName } = item;
      const quantity = parseFloat(Quantity);

      const existingProductIndex = groupedTotalsArray.findIndex(
        (product) => product.Product_ID === Product_ID
      );

      if (existingProductIndex > -1) {
        groupedTotalsArray[existingProductIndex].TotalQuantity += quantity;
      } else {
        groupedTotalsArray.push({
          Product_ID,
          ProductName,
          TotalPrice: Price,
          TotalQuantity: quantity,
        });
      }
    });

    const mergedArray = [];

    groupedTotalsArray.forEach((groupedItem) => {
      const matchingProduct = productTotalsArray.find(
        (product) =>
          product.ProductID === groupedItem.Product_ID ||
          product.ProductName === groupedItem.ProductName
      );

      const remainingQuantity = matchingProduct
        ? matchingProduct.totalSale - groupedItem.TotalQuantity
        : 0;

      mergedArray.push({
        ...groupedItem,
        Price: matchingProduct ? matchingProduct.Price : 0,
        totalSale: matchingProduct ? matchingProduct.totalSale : 0,
        remainingQuantity: remainingQuantity,
      });
    });

    productTotalsArray.forEach((productItem) => {
      const isProductInGrouped = groupedTotalsArray.some(
        (groupedItem) =>
          groupedItem.Product_ID === productItem.ProductID ||
          groupedItem.ProductName === productItem.ProductName
      );

      if (!isProductInGrouped) {
        mergedArray.push({
          Product_ID: productItem.ProductID,
          ProductName: productItem.ProductName,
          TotalPrice: 0,
          TotalQuantity: 0,
          totalSale: productItem.totalSale,
          remainingQuantity: productItem.totalSale,
          Price: productItem.Price,
        });
      }
    });

    // Filter out products with remainingQuantity equal to 0
    const newPurchaseList = mergedArray
      .filter((item) => item.remainingQuantity > 0) // Filter condition
      .map((item) => ({
        ProductName: item.ProductName,
        AccountName: "Cash",
        Product_ID: item.Product_ID,
        Account_ID: CashAccountID,
        Vehicle_No: "",
        Receipt_No: item.Receipt_No,
        Quantity: item.remainingQuantity,
        Price: item.Price,
        Is_Cash: true,
      }));

    setPurchaseList((prevList) => [...prevList, ...newPurchaseList]);
  };

  const handleLastReadingChange = (pumpMachineId, value) => {
    const index = ListofNozzels.findIndex((n) => n.PumpMachineID === pumpMachineId);
    if (index < 0) return;
    const sanitizedValue = value != null || value.length > 0 ? value : 0;

    const newList = [...ListofNozzels];
    newList[index].Last_Reading = sanitizedValue;
    setListofNozzels(newList);

    const updatedList = [...ListofReadings];
    const existingIndex = updatedList.findIndex(
      (item) => item.PumpMachineID === newList[index].PumpMachineID
    );

    if (existingIndex !== -1) {
      updatedList[existingIndex].Last_Reading =
        value != null || value.length > 0 ? value : 0;
    } else {
      updatedList.push({
        PumpMachineID: newList[index].PumpMachineID,
        Last_Reading: sanitizedValue,
        Current_Reading: value != null || value.length > 0 ? value : 0,
        Returned: newList[index].Returned,
      });
    }

    setListofReadings(updatedList);
  };

  const handleCurrentReadingChange = (pumpMachineId, value) => {
    const index = ListofNozzels.findIndex((n) => n.PumpMachineID === pumpMachineId);
    if (index < 0) return;
    const sanitizedValue = value != null || value.length > 0 ? value : 0;

    const newList = [...ListofNozzels];
    newList[index].Current_Reading = sanitizedValue;
    setListofNozzels(newList);

    const updatedList = [...ListofReadings];
    const existingIndex = updatedList.findIndex(
      (item) => item.PumpMachineID === newList[index].PumpMachineID
    );

    if (existingIndex !== -1) {
      updatedList[existingIndex].Current_Reading =
        value != null || value.length > 0 ? value : 0;
    } else {
      updatedList.push({
        PumpMachineID: newList[index].PumpMachineID,
        Last_Reading: newList[index].Last_Reading,
        Current_Reading: value != null || value.length > 0 ? value : 0,
        Returned: newList[index].Returned,
      });
    }

    setListofReadings(updatedList);
  };

  const handleReturnedChange = (pumpMachineId, value) => {
    const index = ListofNozzels.findIndex((n) => n.PumpMachineID === pumpMachineId);
    if (index < 0) return;
    const sanitizedValue = value != null || value.length > 0 ? value : 0;

    const newList = [...ListofNozzels];
    newList[index].Returned = sanitizedValue;
    setListofNozzels(newList);

    const updatedList = [...ListofReadings];
    const existingIndex = updatedList.findIndex(
      (item) => item.PumpMachineID === newList[index].PumpMachineID
    );

    if (existingIndex !== -1) {
      updatedList[existingIndex].Returned =
        value != null || value.length > 0 ? value : 0;
    } else {
      updatedList.push({
        PumpMachineID: newList[index].PumpMachineID,
        Last_Reading: newList[index].Last_Reading,
        Current_Reading: newList[index].Current_Reading,
        Returned: sanitizedValue,
      });
    }

    setListofReadings(updatedList);
  };
  const columnsPumpReadings = [
    {
      title: "Sr.No.",
      dataIndex: "Sr.No.",
      key: "Sr.No.",
      render: (_, record, index) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div className="table-avatar">
            <div className="icon">
              <span>{index + 1}</span>
            </div>
          </div>
          <NozzleOil />
        </div>
      ),
    },
    {
      title: "Product",
      dataIndex: "ProductCode",
      key: "ProductCode",
    },
    {
      title: "Last Reading",
      dataIndex: "Last_Reading",
      key: "Last_Reading",
      render: (_, record) => (
        <Input
          value={record.Last_Reading} // Controlled input value
          placeholder="Last Reading"
          onChange={(e) =>
            handleLastReadingChange(record.PumpMachineID, e.target.value)
          }
        />
      ),
    },
    {
      title: "Current Reading",
      dataIndex: "Current_Reading",
      key: "Current_Reading",
      render: (_, record) => (
        <Input
          value={record.Current_Reading} // Controlled input value
          placeholder="Current Reading"
          onChange={(e) =>
            handleCurrentReadingChange(record.PumpMachineID, e.target.value)
          }
        />
      ),
    },
    {
      title: "Returned",
      dataIndex: "Returned",
      key: "Returned",
      render: (_, record) => (
        <Input
          value={record.Returned}
          placeholder="Returned"
          onChange={(e) =>
            handleReturnedChange(record.PumpMachineID, e.target.value)
          }
        />
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
      render: (_, record) => {
        const quantity = calculateQuantity(record);
        return quantity < 0 ? (
          <span style={{ color: "red", fontSize: "12px" }}>
            {NumberFormat(quantity, 2)}
          </span>
        ) : (
          NumberFormat(quantity, 2)
        );
      },
    },
  ];

  const columnsCreditSale = [
    {
      title: "#",
      dataIndex: "Sr.No.",
      key: "Sr.No.",
      render: (_, record, index) => index + 1,
    },
    {
      title: "Product",
      dataIndex: "ProductName",
      key: "ProductName",
    
    },
    {
      title: "Account",
      dataIndex: "AccountName",
      key: "AccountName",
     
    },
    {
      title: "Vehicle No",
      dataIndex: "Vehicle_No",
      key: "Vehicle_No",
     
    },
    {
      title: "Receipt No",
      dataIndex: "Receipt_No",
      key: "Receipt_No",
      
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
      align: "right",
      render: (_, record) =>
        
          NumberFormat(parseFloat(record.Quantity), 6)
      
    },
    {
      title: "Price",
      dataIndex: "Price",
      key: "Price",
      align: "right",
      render: (_, record) =>
        
          NumberFormat(parseFloat(record.Price), 6)
    },
    {
      title: "Total",
      dataIndex: "Total",
      key: "Total",
      align: "right",
      render: (_, record) => {
        const total = parseFloat(String(record.Total ?? "").replace(/,/g, ""));
        return NumberFormat(
          !isNaN(total) && total !== 0
            ? total
            : parseFloat(record.Price) * parseFloat(record.Quantity),
          6
        );
      },
    },
    {
      title: "Cash",
      dataIndex: "Is_Cash",
      key: "Is_Cash",
      render: (_, record, index) =>
        record.isFormRow ? (
          <Form.Item>
            <Checkbox
              checked={Is_Cash}
              onChange={(e) => setIs_Cash(e.target.checked)}
            >
              Cash
            </Checkbox>
          </Form.Item>
        ) : (
          <Checkbox
            checked={record.Is_Cash}
            onChange={() => handleCheckboxChange(index)}
          />
        ),
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record, index) =>
          <DeleteOutlined onClick={() => handleDelete(index)} />
    },
  ];

  const handleFullScreen = () => {
    setFullScreen((prevState) => !prevState);
  };
  const onChangeWithoutNozzelCheck = (e) => {
    setWithoutNozzel(e.target.checked);
  };

  const handleQtyLock = () => {
    setQtyLocked(true);
    setPriceLocked(false);
  };

  const handleQtyUnlock = () => {
    setQtyLocked(false);
  };

  const handlePriceLock = () => {
    setPriceLocked(true);
    setQtyLocked(false);
  };

  const handlePriceUnlock = () => {
    setPriceLocked(false);
  };

  const showNozzleFlow = ShowNozzles === true && !WithoutNozzel;

  const remainingCashSummary = useMemo(() => {
    if (!showNozzleFlow) {
      return [];
    }

    const productTotalsArray = [];

    ListofNozzels.forEach((item) => {
      const productName = item.ProductName;
      const totalSale = parseFloat(
        item.Current_Reading - item.Last_Reading - item.Returned || 0
      );
      const productIndex = productTotalsArray.findIndex(
        (product) => product.ProductName === productName
      );

      if (productIndex > -1) {
        productTotalsArray[productIndex].totalSale += isNaN(totalSale)
          ? 0
          : totalSale;
      } else {
        productTotalsArray.push({
          ProductID: item.ProductID,
          ProductName: productName,
          totalSale: isNaN(totalSale) ? 0 : totalSale,
          Price: item.Sale_Price,
        });
      }
    });

    const groupedTotalsArray = [];

    purchaseList.forEach((item) => {
      const quantity = parseFloat(item.Quantity);
      const existingProductIndex = groupedTotalsArray.findIndex(
        (product) => product.Product_ID === item.Product_ID
      );

      if (existingProductIndex > -1) {
        groupedTotalsArray[existingProductIndex].TotalQuantity += isNaN(quantity)
          ? 0
          : quantity;
      } else {
        groupedTotalsArray.push({
          Product_ID: item.Product_ID,
          ProductName: item.ProductName,
          TotalQuantity: isNaN(quantity) ? 0 : quantity,
        });
      }
    });

    return productTotalsArray.map((product) => {
      const grouped = groupedTotalsArray.find(
        (entry) =>
          entry.Product_ID === product.ProductID ||
          entry.ProductName === product.ProductName
      );
      const allocated = grouped ? grouped.TotalQuantity : 0;
      return {
        ...product,
        allocated,
        remaining: product.totalSale - allocated,
      };
    });
  }, [showNozzleFlow, ListofNozzels, purchaseList]);

  const totalRemainingCashQty = useMemo(
    () =>
      remainingCashSummary.reduce(
        (sum, item) => sum + Math.max(item.remaining, 0),
        0
      ),
    [remainingCashSummary]
  );

  const saveInvoiceDisabled =
    showNozzleFlow
      ? ListofReadings.length === 0 ||
        purchaseList.length === 0 ||
        ListOfSummary.some((item) => item.PendingQuantity < 0)
      : purchaseList.length === 0;

  const addCashSaleDisabled =
    !showNozzleFlow ||
    ListofReadings.length === 0 ||
    totalRemainingCashQty <= 0;

  const saleDetailsStepNumber = showNozzleFlow ? 2 : ShowNozzles === true ? 2 : 1;
  const saveInvoiceStepNumber = showNozzleFlow ? 4 : ShowNozzles === true ? 3 : 2;

  const renderStepBadge = (stepNumber) => (
    <span className="add-sale-step-badge">{stepNumber}</span>
  );

  const renderStepTitle = (stepNumber, title, subtitle) => (
    <div className="add-sale-step-heading">
      {renderStepBadge(stepNumber)}
      <div>
        <h2>{title}</h2>
        {subtitle ? <p className="add-sale-step-subtitle">{subtitle}</p> : null}
      </div>
    </div>
  );

  return (
    <>
      <LoginChecked />
      <div className={`right-side-contents ${Fullscreen ? "full-screen" : ""}`}>
        <div className="page-content" id="sale-content">
          <div className="page-header">
            <h3 className="page-title">
              <NavLink to="/sales/view-sales">
                <ChevronLeftIcon />
              </NavLink>
              Edit Sale
            </h3>
            <div className="header-actions">
              <div className="button-row">
                <Space>
              <NavLink
                 to={`/sales/printnewsale/${params.id}`}
                target="blank"
              >
                <Button type="dashed" shape="round" size="large">
                  <PrinterOutlined />
                  Download / Print
                </Button>
              </NavLink>
                <Button
                  onClick={handleFullScreen}
                  type="dashed"
                  size="large"
                  shape="round"
                  icon={
                    Fullscreen ? (
                      <FullscreenExitOutlined />
                    ) : (
                      <FullscreenOutlined />
                    )
                  }
                >
                  {Fullscreen ? "Exit Full Screen" : "Full Screen"}
                </Button>
                </Space>
              </div>
            </div>
          </div>

          {bypassEditDaysCheck ? (
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 16 }}
              message="Opened from posting diagnostics"
              description="The usual edit day-limit will be bypassed when you save this sale so you can repair posting issues."
            />
          ) : null}

          {loading ? (
            <>
              <Row gutter={[34, 0]}>
                <Col xs={24} md={16}>
                  <Skeleton active />
                  <Skeleton active />
                </Col>
                <Col xs={24} md={8}>
                  <Skeleton active />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row gutter={[24, 10]} className="mb-5">
                <Col md={3} xs={24}>
                  <Form.Item className="input-vertical" label="Invoice No">
                    <Input value={InvoiceNo} readOnly />
                  </Form.Item>
                </Col>
                <Col md={4} xs={24}>
                  <Form.Item className="input-vertical" label="Date">
                    <DatePicker
                      defaultValue={Dated}
                      style={{ width: "100%" }}
                      onChange={handleDate}
                    />
                  </Form.Item>
                </Col>
                <Col md={17} xs={24}>
                  <Form.Item className="input-vertical" label="Description">
                    <Input
                      value={Description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[24, 24]} align="middle" className="mb-5">
                {ShowNozzles === true ? (
                  <>
                    <Col md={showNozzleFlow ? 16 : 24}>
                      <div className="fb-card add-sale-step-card">
                        <div className="fb-card-header">
                          <div className="fb-card-title">
                            {renderStepTitle(
                              1,
                              "Enter Pump Readings",
                              showNozzleFlow
                                ? "Record current nozzle readings for each pump."
                                : "Nozzle readings skipped for this invoice."
                            )}
                          </div>
                          <div className="fb-card-action">
                            <Checkbox
                              checked={WithoutNozzel}
                              onChange={onChangeWithoutNozzelCheck}
                            >
                              Proceed without Nozzle Sale
                            </Checkbox>
                          </div>
                        </div>
                        {showNozzleFlow ? (
                          <div className="fb-card-body table">
                            <Table
                              columns={columnsPumpReadings}
                              dataSource={sortedNozzlesForTable}
                              rowKey="PumpMachineID"
                              pagination={false}
                              loading={loading}
                              scroll={{ x: "100%" }}
                            />
                          </div>
                        ) : null}
                      </div>
                    </Col>
                    {showNozzleFlow ? (
                      <Col md={8}>
                        {nozzleProductTotals.map((item) => (
                          <div
                            className="add-sale-nozzle-summary"
                            key={
                              item.ProductID != null
                                ? `pid-${item.ProductID}`
                                : `${item.ProductCode}-${item.ProductName}`
                            }
                          >
                            <Space direction="vertical" size={10}>
                              <BoxCard
                                style={{ minWidth: "300px" }}
                                title={`Total ${item.ProductName} Sale`}
                                loading={loading}
                                amount={NumberFormat(item.totalQuantity, 2)}
                                suffix="Ltr"
                                icon={<NozzleOil />}
                              />
                            </Space>
                          </div>
                        ))}
                      </Col>
                    ) : null}
                  </>
                ) : null}

                <Col md={24}>
                  <div className="fb-card add-sale-step-card">
                    <div className="fb-card-header">
                      <div className="fb-card-title">
                        {renderStepTitle(
                          saleDetailsStepNumber,
                          showNozzleFlow
                            ? "Enter Credit Sale Details"
                            : "Enter Sale Details",
                          showNozzleFlow
                            ? "Add credit lines until pump quantities are fully allocated."
                            : "Add products, accounts, and sale amounts."
                        )}
                      </div>
                    </div>
                    <div className="fb-card-body">
                      <Row gutter={20}>
                        <Col md={7} sm={24} xs={24}>
                          <div className="add-sale-form-panel">
                            <Form
                              onFinish={handleSubmit}
                              form={form}
                              layout="vertical"
                            >
                            <Row gutter={[10, 5]} align="middle">
                              <Col md={24} sm={24} xs={24}>
                                <Form.Item
                                  name="Product_ID"
                                  label="Select Product"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select a product!",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    style={{ minWidth: "150px" }}
                                    placeholder="Select Product"
                                    loading={!productTypesArray}
                                    options={productTypesArray}
                                    onChange={handleProductChange}
                                    optionFilterProp="label"
                                    filterOption={(input, option) =>
                                      option.label
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col md={24} sm={24} xs={24}>
                                <Form.Item
                                  name="Account_ID"
                                  label="Select Account"
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please select an account!",
                                    },
                                  ]}
                                >
                                  <Select
                                    showSearch
                                    style={{ minWidth: "160px" }}
                                    placeholder="Select Account"
                                    loading={!accountTypesArray}
                                    options={accountTypesArray}
                                    onChange={handleAccountChange}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      option.label
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                  />
                                </Form.Item>
                                <div className="add-sale-rate-toggle">
                                  <Tooltip title="Product's standard Sale Price.">
                                    <span
                                      className={`add-sale-rate-label${
                                        !useCustomerRate ? " is-active" : ""
                                      }`}
                                    >
                                      Cash Rate
                                      <QuestionCircleOutlined className="add-sale-rate-help" />
                                    </span>
                                  </Tooltip>
                                  <Switch
                                    checked={useCustomerRate}
                                    onChange={handleRateTypeChange}
                                    loading={RateLoading || productRateLoading}
                                  />
                                  <Tooltip title="Uses the saved selling rate for the selected customer account.">
                                    <span
                                      className={`add-sale-rate-label${
                                        useCustomerRate ? " is-active" : ""
                                      }`}
                                    >
                                      Customer Rate
                                      <QuestionCircleOutlined className="add-sale-rate-help" />
                                    </span>
                                  </Tooltip>
                                </div>
                              </Col>
                              <Col md={12} sm={24} xs={24}>
                                <Form.Item name="Vehicle_No" label="Vehicle No">
                                  <Input placeholder="Vehicle No" />
                                </Form.Item>
                              </Col>
                              <Col md={12} sm={24} xs={24}>
                                <Form.Item name="Receipt_No" label="Receipt No">
                                  <Input placeholder="Receipt No" />
                                </Form.Item>
                              </Col>
                              <Col md={12} sm={24} xs={24}>
                                <Form.Item
                                  name="Quantity"
                                  label={
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Quantity
                                      {QtyLocked ? (
                                        <LockClosedIcon
                                          onClick={handleQtyUnlock}
                                          style={{
                                            width: 16,
                                            cursor: "pointer",
                                            marginLeft: "5px",
                                          }}
                                        />
                                      ) : (
                                        <LockOpenIcon
                                          onClick={handleQtyLock}
                                          style={{
                                            width: 16,
                                            cursor: "pointer",
                                            marginLeft: "5px",
                                          }}
                                        />
                                      )}
                                    </span>
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter quantity!",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Quantity"
                                    onChange={handleQuantity}
                                    style={{ minWidth: "70px" }}
                                    disabled={QtyLocked}
                                  />
                                </Form.Item>
                              </Col>

                              <Col md={12} sm={24} xs={24}>
                                <Form.Item
                                  name="Price"
                                  // label="Price"
                                  label={
                                    <span
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Price
                                      {PriceLocked ? (
                                        <LockClosedIcon
                                          onClick={handlePriceUnlock}
                                          style={{
                                            width: 16,
                                            cursor: "pointer",
                                            marginLeft: "5px",
                                          }}
                                        />
                                      ) : (
                                        <LockOpenIcon
                                          onClick={handlePriceLock}
                                          style={{
                                            width: 16,
                                            cursor: "pointer",
                                            marginLeft: "5px",
                                          }}
                                        />
                                      )}
                                    </span>
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter price!",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Price"
                                    onChange={handlePriceChange}
                                    disabled={PriceLocked}
                                  />
                                </Form.Item>
                              </Col>
                              <Col md={12} sm={24} xs={24}>
                                <Form.Item name="Total" label="Total">
                                  <Input
                                    placeholder="Total"
                                    onChange={handleTotalChange}
                                  />
                                </Form.Item>
                              </Col>
                              <Col md={12}>
                                <Form.Item label="" style={{ marginBottom: 0 }}>
                                  <Checkbox
                                    checked={Is_Cash}
                                    onChange={(e) =>
                                      setIs_Cash(e.target.checked)
                                    }
                                  >
                                    Cash
                                  </Checkbox>
                                </Form.Item>
                              </Col>
                              <Col md={12}>
                                <Form.Item label="" style={{ marginBottom: 0 }}>
                                  <Checkbox
                                    checked={dontClearForm}
                                    onChange={(e) =>
                                      setDontClearForm(e.target.checked)
                                    }
                                  >
                                    Don't clear form
                                  </Checkbox>
                                </Form.Item>
                              </Col>
                              <Col md={24} sm={24} xs={24}>
                                <Button
                                  type="primary"
                                  shape="round"
                                  htmlType="submit"
                                  size="large"
                                  style={{ width: "100%" }}
                                >
                                  Add
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                      </Col>
                      <Col md={17} sm={24}>
                        <div className="add-sale-right-column">
                          <Table
                            columns={columnsCreditSale}
                            dataSource={purchaseList}
                            pagination={false}
                            loading={loading}
                            scroll={{ x: "100%" }}
                            summary={() =>
                              totals.totalPrice > 0 && (
                                <>
                                  <Table.Summary.Row className="table-footer">
                                    <Table.Summary.Cell colSpan={7} align="right">
                                      <b>Total Sale</b>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell align="left" colSpan={3}>
                                      {NumberFormat(totals.totalPrice, 6)}
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell colSpan={7} align="right">
                                      <b>Total Cash Sale</b>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell align="left" colSpan={3}>
                                      {NumberFormat(totals.cashSaleTotal, 6)}
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell colSpan={7} align="right">
                                      <b>Total Credit Sale</b>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell align="left" colSpan={3}>
                                      {NumberFormat(totals.creditSaleTotal, 6)}
                                    </Table.Summary.Cell>
                                  </Table.Summary.Row>
                                </>
                              )
                            }
                          />

                          {showNozzleFlow ? (
                            <div className="add-sale-inline-step">
                              <div className="add-sale-inline-step-header">
                                {renderStepTitle(
                                  3,
                                  "Add Cash Sale",
                                  "Auto-add remaining pump quantity as cash sale lines."
                                )}
                              </div>
                              <div className="add-sale-action-panel">
                                {remainingCashSummary.length > 0 ? (
                                  <ul className="add-sale-remaining-list add-sale-remaining-list--compact">
                                    {remainingCashSummary.map((item) => (
                                      <li
                                        key={`${item.ProductID}-${item.ProductName}`}
                                        className={
                                          item.remaining > 0
                                            ? "is-pending"
                                            : item.remaining < 0
                                            ? "is-over"
                                            : "is-complete"
                                        }
                                      >
                                        <span className="add-sale-remaining-product">
                                          {item.ProductName}
                                        </span>
                                        <span className="add-sale-remaining-meta">
                                          Qty: {NumberFormat(item.totalSale, 2)} Ltr
                                        </span>
                                        <span className="add-sale-remaining-meta">
                                          Allocated: {NumberFormat(item.allocated, 2)} Ltr
                                        </span>
                                        <span className="add-sale-remaining-value">
                                          Remaining: {NumberFormat(item.remaining, 2)} Ltr
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <p className="add-sale-step-helper">
                                    Enter pump readings in Step 1 to calculate remaining
                                    cash quantities.
                                  </p>
                                )}
                                <div className="add-sale-action-row">
                                  <Button
                                    type="default"
                                    size="large"
                                    shape="round"
                                    icon={<PlusCircleOutlined />}
                                    onClick={AddCashSale}
                                    disabled={addCashSaleDisabled}
                                  >
                                    Add Cash Sale
                                  </Button>
                                  {totalRemainingCashQty > 0 ? (
                                    <span className="add-sale-step-helper">
                                      {NumberFormat(totalRemainingCashQty, 2)} Ltr still
                                      unallocated as cash.
                                    </span>
                                  ) : remainingCashSummary.length > 0 ? (
                                    <span className="add-sale-step-helper is-success">
                                      All pump quantities are allocated.
                                    </span>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="add-sale-inline-step add-sale-inline-step--save">
                            <div className="add-sale-inline-step-header">
                              {renderStepTitle(
                                saveInvoiceStepNumber,
                                "Update Invoice",
                                "Review totals and update this sale invoice."
                              )}
                            </div>
                            <div className="add-sale-action-panel">
                              <ul className="add-sale-save-summary add-sale-save-summary--compact">
                                <li>
                                  <span>Total sale</span>
                                  <strong>{NumberFormat(totals.totalPrice, 2)}</strong>
                                </li>
                                <li>
                                  <span>Cash sale</span>
                                  <strong>{NumberFormat(totals.cashSaleTotal, 2)}</strong>
                                </li>
                                <li>
                                  <span>Credit sale</span>
                                  <strong>{NumberFormat(totals.creditSaleTotal, 2)}</strong>
                                </li>
                                <li>
                                  <span>Line items</span>
                                  <strong>{purchaseList.length}</strong>
                                </li>
                              </ul>
                              <div className="add-sale-action-row">
                                <Button
                                  onClick={handleSaveInvoice}
                                  type="primary"
                                  size="large"
                                  shape="round"
                                  icon={<SaveOutlined />}
                                  loading={loadingAddSale}
                                  disabled={saveInvoiceDisabled}
                                >
                                  Update Invoice
                                </Button>
                                {saveInvoiceDisabled ? (
                                  <span className="add-sale-step-helper">
                                    {showNozzleFlow
                                      ? "Complete pump readings and add at least one sale line."
                                      : "Add at least one sale line before updating."}
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default EditSales;
